import i18n from "./i18n";

const prettyRound = (number, breakPoints = [1000, 100, 10, 1]) => {
  const absNumber = Math.abs(number);
  for (const breakPoint of breakPoints) {
    if (absNumber > breakPoint) {
      const rounded = Math.round(absNumber / breakPoint) * breakPoint;
      return number < 0 ? -rounded : rounded;
    }
  }
  return number;
};

const currency = (input, round = false) => {
  if (typeof input !== "number") {
    return input;
  }
  const currency = i18n.t("js.helpers.currency");

  return delimitedValue(input, round) + " " + currency;
};

const delimitedValue = (input, round = false) => {
  if (typeof input !== "number") {
    return input;
  }
  const number = round ? prettyRound(input) : Math.round(input);

  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
};

const emissionNumber = (input) => {
  if (typeof input !== "number") {
    return input;
  }
  return delimitedValue(prettyRound(input, [100, 10, 1]), false);
};

const emissionUnit = () => i18n.t("js.helpers.emission_unit");

const emissions = (input) => {
  if (typeof input !== "number") {
    return input;
  }

  return emissionNumber(input) + " " + emissionUnit();
};

const energy = (input) => {
  if (typeof input !== "number") {
    return input;
  }
  const unit = i18n.t("js.helpers.energy_unit");

  return (
    prettyRound(input, [100, 10, 1])
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, " ") +
    " " +
    unit
  );
};

const qs = (params, prefix) => {
  let str = [];

  Object.keys(params).forEach((key) => {
    let param = prefix ? prefix + "[" + key + "]" : key;
    if (Array.isArray(params)) {
      param = prefix ? prefix + "[]" : key;
    }
    const value = params[key];
    if (value !== null && typeof value === "object") {
      str.push(qs(value, param));
    } else {
      str.push(
        encodeURIComponent(param) +
          "=" +
          encodeURIComponent(value === undefined ? "" : value)
      );
    }
  });

  return str.join("&");
};

const classSet = (...args) => {
  const classObject = args.reduce((obj, arg) => {
    if (Boolean(arg) === false) {
      return obj;
    }
    if (typeof arg === "object") {
      return Object.assign(obj, arg);
    }
    return Object.assign(obj, { [arg]: true });
  }, {});

  const classNames = Object.keys(classObject)
    .map((className) => (classObject[className] ? className : null))
    .filter((className) => Boolean(className));

  return classNames.join(" ");
};

const escapeHTML = (unsafe) =>
  unsafe
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");

const pushUnique = (array, item) => {
  if (!array.includes(item)) {
    array.push(item);
  }
};

export {
  currency,
  emissionNumber,
  emissionUnit,
  emissions,
  energy,
  prettyRound,
  qs,
  classSet,
  escapeHTML,
  delimitedValue,
  pushUnique,
};
